import moment from 'moment';

import {
  SET_IS_LOADING,
  SET_SCHEDULING_CONFIGURATION,
  CLEAR_SCHEDULING_CONFIGURATION
} from './constants';

const defaultState = {
  isLoading: false,
  id: '',
  mandatoryClient: 0,
  weeklyConfig: [
    {
      day: 'Seg',
      dayId: 1,
      dayName: 'monday',
      availability: [
        {
          startTime: '08:00',
          endTime: '18:00'
        }
      ]
    },
    {
      day: 'Ter',
      dayId: 2,
      dayName: 'tuesday',
      availability: [
        {
          startTime: '08:00',
          endTime: '18:00'
        }
      ]
    },
    {
      day: 'Qua',
      dayId: 3,
      dayName: 'wednesday',
      availability: [
        {
          startTime: '08:00',
          endTime: '18:00'
        }
      ]
    },
    {
      day: 'Qui',
      dayId: 4,
      dayName: 'thursday',
      availability: [
        {
          startTime: '08:00',
          endTime: '18:00'
        }
      ]
    },
    {
      day: 'Sex',
      dayId: 5,
      dayName: 'friday',
      availability: [
        {
          startTime: '08:00',
          endTime: '18:00'
        }
      ]
    },
    {
      day: 'Sáb',
      dayId: 6,
      dayName: 'saturday',
      availability: [
        {
          startTime: '08:00',
          endTime: '18:00'
        }
      ]
    },
    {
      day: 'Dom',
      dayId: 0,
      dayName: 'sunday',
      availability: [
        {
          startTime: '08:00',
          endTime: '18:00'
        }
      ]
    }
  ],
  yearlyConfig: [
    {
      day: moment().startOf('year').format('YYYY-MM-DD'),
      availability: [
        {
          startTime: '08:00',
          endTime: '18:00'
        }
      ]
    }
  ]
}

export default (state = defaultState, action) => {
  switch(action.type) {
    case SET_IS_LOADING: {
      return {
        ...state,
        isLoading: action.isLoading
      }
    }
    case SET_SCHEDULING_CONFIGURATION: {
      const { id, mandatoryClient, weeklySettings, dayOfMonthSettings } = action?.data || {};

      const monday = weeklySettings
        ?.filter(item => item?.dayOfWeek == 'monday')
        ?.map(item => {
          return {
            startTime: item?.startTime?.slice(0, 5),
            endTime: item?.endTime?.slice(0, 5)
          }
        });

      const tuesday = weeklySettings
        ?.filter(item => item?.dayOfWeek == 'tuesday')
        ?.map(item => {
          return {
            startTime: item?.startTime?.slice(0, 5),
            endTime: item?.endTime?.slice(0, 5)
          }
        });

      const wednesday = weeklySettings
        ?.filter(item => item?.dayOfWeek == 'wednesday')
        ?.map(item => {
          return {
            startTime: item?.startTime?.slice(0, 5),
            endTime: item?.endTime?.slice(0, 5)
          }
        });

      const thursday = weeklySettings
        ?.filter(item => item?.dayOfWeek == 'thursday')
        ?.map(item => {
          return {
            startTime: item?.startTime?.slice(0, 5),
            endTime: item?.endTime?.slice(0, 5)
          }
        });

      const friday = weeklySettings
        ?.filter(item => item?.dayOfWeek == 'friday')
        ?.map(item => {
          return {
            startTime: item?.startTime?.slice(0, 5),
            endTime: item?.endTime?.slice(0, 5)
          }
        });

      const saturday = weeklySettings
        ?.filter(item => item?.dayOfWeek == 'saturday')
        ?.map(item => {
          return {
            startTime: item?.startTime?.slice(0, 5),
            endTime: item?.endTime?.slice(0, 5)
          }
        });

      const sunday = weeklySettings
        ?.filter(item => item?.dayOfWeek == 'sunday')
        ?.map(item => {
          return {
            startTime: item?.startTime?.slice(0, 5),
            endTime: item?.endTime?.slice(0, 5)
          }
        });

      const daysOfYear = Array.from(new Set([ ...dayOfMonthSettings?.map(item => item?.dayOfMonth) ]));

      const formattedDaysOfYear = daysOfYear
        ?.map(day => {
          const daySettings = dayOfMonthSettings?.filter(item => item?.dayOfMonth == day) || [];
          const isUnavailable = daySettings.some(item => item?.deletedAt != null);

          return {
            day,
            availability: isUnavailable ? [] : daySettings.map(item => {
              return {
                startTime: item?.startTime?.slice(0, 5),
                endTime: item?.endTime?.slice(0, 5)
              }
            })
          }
        })
        ?.sort((firstDate, secondDate) => moment.utc(firstDate?.day).diff(moment.utc(secondDate?.day)));

      return {
        ...state,
        id,
        mandatoryClient: +mandatoryClient,
        weeklyConfig: [
          {
            day: 'Seg',
            dayId: 1,
            dayName: 'monday',
            availability: monday
          },
          {
            day: 'Ter',
            dayId: 2,
            dayName: 'tuesday',
            availability: tuesday
          },
          {
            day: 'Qua',
            dayId: 3,
            dayName: 'wednesday',
            availability: wednesday
          },
          {
            day: 'Qui',
            dayId: 4,
            dayName: 'thursday',
            availability: thursday
          },
          {
            day: 'Sex',
            dayId: 5,
            dayName: 'friday',
            availability: friday
          },
          {
            day: 'Sáb',
            dayId: 6,
            dayName: 'saturday',
            availability: saturday
          },
          {
            day: 'Dom',
            dayId: 0,
            dayName: 'sunday',
            availability: sunday
          }
        ],
        yearlyConfig: formattedDaysOfYear
      }
    }
    case CLEAR_SCHEDULING_CONFIGURATION: {
      return defaultState;
    }
    default: {
      return state;
    }
  }
}